import { Grid2X2, ShoppingBag } from 'lucide-react'
import { Column } from 'src/shared/components/Semantic/all'
import { EmptyState } from 'src/shared/components/EmptyState'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import { IMAGE_URLS } from 'src/assets/urlLinks'

export const OrderEmptyState = ({
  variant,
}: {
  variant: 'chat' | 'catalog'
}) => {
  const { t } = useLocalization()

  const chatConfig = {
    description: t(
      'Add products from the chat',
      'Lägg till produkter från chatten'
    ),
    image: IMAGE_URLS.images.teamKit,
    button: undefined,
  }

  const catalogConfig = {
    image: IMAGE_URLS.images.teamKit,
    button: (
      <p className="text-gray-500 text-center">
        {t(
          'Add products from the chat or browse the catalog.',
          'Lägg till produkter från chatten eller bläddra i katalogen.'
        )}
        <Grid2X2 className="w-4 h-4 ml-2 text-gray-500 inline-block mb-1" />
      </p>
    ),
  }

  const config = variant === 'chat' ? chatConfig : catalogConfig

  return (
    <Column className="justify-center items-center m-auto">
      <EmptyState
        withCard={false}
        icon={<ShoppingBag className="w-9 h-9" />}
        title={t('No products in this order', 'Inga produkter i denna order')}
        image={config.image}
        button={config.button}
      />
    </Column>
  )
}
